import { apiSlice } from "@app/api/apiSlice";

export const errorClientApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    loadClientError: builder.mutation({
      query: (query) => `clientBug?${query}`,
    }),
    deleteError: builder.mutation({
      query: (query) => ({
        url: "clientBug/deleteAll",
        method: "POST",
      }),
    }),
    deleteMultipleErrorRequest: builder.mutation({
      query: (body) => ({
        url: "clientBug/deleteMultiple",
        method: "POST",
        body,
      }),
    }),
    deleteAll: builder.mutation({
      query: (query) => ({
        url: "clientBug/deleteAll",
        method: "POST",
      }),
    }),
    logError: builder.mutation({
      query: (body) => ({
        url: "clientBug",
        method: "POST",
        body,
      }),
    }),
  }),
  overrideExisting: true,
});

export const {
  useLoadClientErrorMutation,
  useDeleteErrorMutation,
  useDeleteMultipleErrorRequestMutation,
  useDeleteAllMutation,
  useLogErrorMutation,
} = errorClientApiSlice;
